import React from 'react'
import ExperienceFormTab from './ExperienceFormTab'

const VirtualFormTab: React.FC = (props) => {
  return (
    <ExperienceFormTab
      {...props}
      experience="virtuals"
      experienceService="virtualService"
    />
  )
}

export default VirtualFormTab
